module.exports = __webpack_public_path__ + "media/coin.0b311475.mp4";